import { useEffect } from 'react';

export default function FormActionEnhancer() {
  useEffect(() => {
    const findHeaderHost = (row) => {
      const dialog = row.closest('.p-dialog');
      const scope = dialog || row.closest('.card.app-card') || row.closest('.card');
      if (!scope) return null;

      const isBeforeActions = (candidate) => (
        candidate !== row
        && Boolean(candidate.compareDocumentPosition(row) & Node.DOCUMENT_POSITION_FOLLOWING)
      );
      const header = Array.from(scope.querySelectorAll('.card-header')).find(isBeforeActions)
        || (dialog ? Array.from(scope.querySelectorAll('.p-dialog-header')).find(isBeforeActions) : null);

      if (!header) return null;

      const parent = header.parentElement;
      if (parent && parent.classList.contains('card') && parent.children.length === 1) return parent;
      return header;
    };

    // Botões com "title" + ícone + texto não são só-ícone: marca para o CSS
    // não reduzir a largura para 42px.
    const markTextButtons = () => {
      document.querySelectorAll('.btn[title]').forEach((button) => {
        // Ícones .pi não têm texto (são pseudo-elementos); qualquer texto indica rótulo.
        const hasText = button.textContent.trim() !== '';
        if (hasText !== button.classList.contains('btn-has-text')) {
          button.classList.toggle('btn-has-text', hasText);
        }
      });
    };

    const enhanceActions = () => {
      markTextButtons();
      document.querySelectorAll('.row').forEach((row) => {
        const saveButton = row.querySelector('.btn .pi-check, .btn .pi-save, .p-button:not(.p-togglebutton) .pi-check, .p-button:not(.p-togglebutton) .pi-save');
        const cancelButton = row.querySelector('.btn .pi-times, .p-button:not(.p-togglebutton) .pi-times');

        if (!saveButton || !cancelButton) return;

        const saveButtonElement = saveButton.closest('.btn, .p-button');
        const cancelButtonElement = cancelButton.closest('.btn, .p-button');
        const actionsContainer = saveButtonElement.parentElement;

        if (saveButtonElement.closest('.row') !== row || cancelButtonElement.closest('.row') !== row) return;

        if (actionsContainer) actionsContainer.classList.add('form-action-buttons');
        saveButtonElement.classList.add('form-save-button');
        cancelButtonElement.classList.add('form-cancel-button');
        row.dataset.actionsEnhanced = 'true';

        const headerHost = findHeaderHost(row);

        // Cabeçalho no padrão "botoesFinalizar": título e botões dentro do próprio .card-header.
        // Mantém tudo na mesma linha: título à esquerda e Cancelar/Salvar à direita.
        if (headerHost && actionsContainer && headerHost.contains(row)) {
          headerHost.classList.add('form-header-bar', 'form-header-inline-host');
          actionsContainer.classList.add('form-header-actions');
          row.classList.remove('form-action-top-row', 'form-action-row');
          row.classList.add('form-header-inline');
          const actionCol = Array.from(row.children).find(child => child.contains(actionsContainer));
          Array.from(row.children).forEach(child => {
            child.classList.add(child === actionCol ? 'form-header-inline-actions' : 'form-header-inline-title');
          });
          return;
        }

        if (headerHost && actionsContainer) {
          const actionScope = row.closest('.p-dialog') || row.closest('.card.app-card') || row.closest('.card');
          headerHost.classList.add('form-header-bar');
          if (actionScope) actionScope.classList.add('form-with-top-actions');
          actionsContainer.classList.add('form-header-actions');
          row.classList.add('form-action-top-row');
          if (headerHost.classList.contains('p-dialog-header')) {
            // Dialog: botões na linha do título, à direita (antes do "X" de fechar).
            if (actionScope) actionScope.classList.add('form-dialog-top-actions');
            row.classList.add('form-action-dialog-row');
            const actionCol = Array.from(row.children).find(child => child.contains(actionsContainer));
            if (actionCol) actionCol.classList.add('form-action-dialog-col');
          }
          return;
        }

        row.classList.add('form-action-row');
      });
    };

    enhanceActions();

    const observer = new MutationObserver(enhanceActions);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}




